import React, { useEffect } from 'react';
import { Card, Gradient } from '../../Global/styles';
import { Place } from '../../../models/Place';
import { NavLink } from 'react-router-dom';
import { checkImage } from '../../componentUtils';
import { CardTitleContainer } from './carouselStyles';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';
import { PlaceHelper } from '../../../models/helpers/Helpers';
import BookmarkPlaceButton from '../../Global/BookmarkButton/BookmarkPlaceButton';

type CarouselItemProps = {
	item: Place;
};

const CarouselItem: React.FC<CarouselItemProps> = ({ item }) => {
	return (
		<>
			<Card $height={360}>
				<NavLink to={'/place/' + item.id}>
					<LoadingImage src={checkImage(item.image)} />
					<Gradient />
					<CardTitleContainer>
						<h3>{item.title}</h3>
						<p>{PlaceHelper.generateMetaString(item)}</p>
					</CardTitleContainer>
				</NavLink>
				<BookmarkPlaceButton placeId={item.id} />
			</Card>
		</>
	);
};

export default CarouselItem;
